//#region package/geometry/provides.ts
var macros = { geometry: {
	signature: "m",
	renderInfo: {
		breakAround: true,
		pgfkeysArgs: true
	}
} };
var environments = {};
//#endregion
export { environments, macros };

//# sourceMappingURL=index.js.map